import React, { useEffect } from "react";
import "./detailChecklist.scss";
import BreakLine from "../../../component/Desktop/breakLine";
import { lang, TYPE_INPUT } from "../../../constants/common.const";
import kbn from "../../../api/backend/kbn";
function PreviewData({ data, isPC,haveConfig }) {
  const getConfig  = async() => {
    try {
    const res = await kbn.getConfigJubmentSelect()
    } catch (error) {
      
    }
  }
  useEffect(() => {
  getConfig()
  },[])
  const symbolMapping = {
    "レ": "レ: 異常なし",
    "×": "×:異常あり",
    "△": "△:調整中",
    "◇": "◇:休止中",
    "－": "－:記入不要"
};
  const getValue = ({ mode, value,checkItemName }) => {
    if (mode === TYPE_INPUT.RATIO) {
      if (value === "1") {
        return lang.YES;
      } else if (value === "0") {
        return lang.NO;
      }
    }
    if(mode === TYPE_INPUT.SELECT ){
      const isJudge = typeof checkItemName === "string" &&  checkItemName.includes(lang.JUDGEMENT);
      if(isJudge &&  (value === null || value === undefined || value === "")){
        return lang.JUDGEMENT
      }
      if(haveConfig){
        return symbolMapping[value] || value
      }
      
    }
    return value;
  };
  const renderData = () => {
    let sub;
    if (!data || !Array.isArray(data) || data.length === 0) {
      sub = 3;
    } else if (data.length >= 3) {
      sub = 3;
    } else {
      sub = data.length;
    }

    return (data || []).map((tab) => (
      <div
        style={{
          flexBasis: !isPC ? "100%" : `calc(100% / ${sub} - 10px)`,
        }}
        className="previewCLItem"
        key={tab.title}
      >
        <div className="titleTabPreview">{tab.title}</div>
        {tab.checklistMachines &&
          tab.checklistMachines.map((machine) => (
            <div key={machine.id}>
              {tab.checklistMachines && (
                <div className="titleMachinePreview">
                  {machine.titleMachine || machine.machineForSiteOfficeName}
                </div>
              )}
              {machine.checkItems &&
                machine.checkItems.map((itemCheck) => (
                  <div className="wrapTitleItemCheckPreview ">
                    <div className="titleItemCheckPreview titleItemCheckPreviewName">
                      {itemCheck.checkItemName}{" "}
                    </div>
                    <div className="titleItemCheckPreview titleItemCheckPreviewContent">
                      {getValue(itemCheck)}
                    </div>
                    <div className="titleItemCheckPreview titleItemCheckPreviewUnit">
                      {itemCheck.unit}
                    </div>
                  </div>
                ))}
            </div>
          ))}
        {tab.checklistItemPreChecks &&
          tab.checklistItemPreChecks.map((itemCheck) => (
            <div
              style={{
                background: "transparent",
              }}
              className=" wrapTitleItemCheckPreview"
            >
              <div className="titleItemCheckPreview titleItemCheckPreviewName">
                {itemCheck.checkItemName} {" "}
              </div>
              <div className="titleItemCheckPreview titleItemCheckPreviewContent">
                {getValue(itemCheck)}
              </div>
              <div className="titleItemCheckPreview titleItemCheckPreviewUnit">
                {itemCheck.unit}
              </div>
            </div>
          ))}
        {/* {!isPC &&  <BreakLine style={{marginTop:15}} />} */}
      </div>
    ));
  };
  return (
    <div
      style={{
        flexWrap: !isPC ? "wrap" : "nowrap",
      }}
      className="previewCLContainer"
    >
      {renderData()}
    </div>
  );
}

export default PreviewData;
